export const REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  PASSWORD: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z\d])[A-Za-z\d\S]{8,12}$/,
  ALPHA_NUMERIC_WITH_SPACE: /^(?![ ])[a-zA-Z0-9 ]*$/,
};
